import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { Observable, of } from 'rxjs';
import { GridData } from '@tesla/angular2-tesla-common/grid/grid.models';
import Helper from 'src/app/core/utility/helper';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { ValidateProposalOverrideFields } from 'src/app/commonUI/customValidators/proposaloverridelfields.validator';
import { debuglog } from 'util';
import { ProposalImage } from 'src/app/models/proposal-image';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import { FileToBeUploaded } from 'src/app/models/internal/file-tobe-uploaded';
import { ImageToBeDeleted } from 'src/app/models/internal/image-tobe-deleted';
import { DunnageType } from 'src/app/models/dunnagetype';
import { Constants } from 'src/app/core/constants';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';

@Component({
    selector: 'app-proposaloverride',
    templateUrl: './proposaloverride.component.html',
    styleUrls: ['./proposaloverride.component.scss'],
})
export class ProposaloverrideComponent extends BaseGridPage implements OnInit {
    @Output() private formReady: EventEmitter<FormGroup> = new EventEmitter<
        FormGroup
    >();
    @Output() private imageDeleteClicked: EventEmitter<
        ImageToBeDeleted
    > = new EventEmitter<ImageToBeDeleted>();
    @Output() private newImageUploaded: EventEmitter<
        FileToBeUploaded
    > = new EventEmitter<FileToBeUploaded>();
    @Input() OkTOUploadImages: boolean;
    proposalOverrideForm: FormGroup;
    partinfoList: PartBasicInfo[];
    isInboundShipment: boolean = true;
    allItemsCheckBoxSelected: boolean = false;
    createproposalDTO: CreateProposalDTO;
    partsToBeoverridden: PartInfo[] = [];
    partImages: ProposalImage[] = [];
    packageImages: ProposalImage[] = [];
    proposalId: number;
    SecondaryotherDunnageTypeSelected: boolean = false;
    PrimaryotherDunnageTypeSelected: boolean = false;
    public dunnageTypes: DunnageType[];
    public dunnageTypePrimaryList: DunnageType[];
    public dunnageTypeSecondaryList: DunnageType[];
    public formErrors = {
        Length: '',
        Width: '',
        Height: '',
        Weight: '',
        PrimaryTareWeight: '',
        SecondaryTareWeight: '',
        QPC: '',
        SecondaryContainersPerLayer: '',
        SecondaryNoOfLayers: '',
        // IsDunnageRequired: [false],
        PrimaryDunnageType: '',
        SecondaryDunnageType: '',
        PrimaryDunnage: '',
        SecondaryDunnage: '',
        TertiaryTareWeight: '',
        TertiaryContainersPerLayer: '',
        TertiaryNoOfLayers: ''
    };

    constructor(
        private fb: FormBuilder,
        public formService: FormService,
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings,
        private proposalService: ProposalService
    ) {
        super(localstorageService, logger, appSettings);
        this.proposalOverrideForm = this.fb.group({
            Length: [null],
            Width: [null],
            Height: [null],
            Weight: [null],
            PrimaryTareWeight: [null],
            SecondaryTareWeight: [null],
            QPC: [null],
            SecondaryContainersPerLayer: [null],
            SecondaryNoOfLayers: [null],
            // IsDunnageRequired: [false],
            PrimaryDunnageType: [''],
            SecondaryDunnageType: [''],
            PrimaryDunnage: [''],
            SecondaryDunnage: [''],
            TertiaryTareWeight: [null],
            TertiaryContainersPerLayer: [null],
            TertiaryNoOfLayers: [null]
        });
    }

    ngOnInit() {
        this.proposalService.partInfoList.subscribe(parts => {
            this.partinfoList = parts;
            this.gridView = of({
                data: parts,
                total: parts.length,
            });
        });
        this.proposalService.createProposalDTO.subscribe(prop => {
            this.createproposalDTO = prop;
        });
        this.proposalService.dunnageTypeMasterList.subscribe(dunnageTypes => {
            this.dunnageTypes = dunnageTypes;
            this.setDunnageTypes(dunnageTypes);
        });
        this.formReady.emit(this.proposalOverrideForm);
        this.proposalOverrideForm.valueChanges.subscribe(data => {
            this.ValidateForm();
        });
    }
    fillGrid(): void {
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.allItemsCheckBoxSelected = false;
    }

    setControlValues(prop: CreateProposalDTO) {
        {
            this.proposalId = prop.DefaultProposal.ProposalId;
            if (
                prop.OverriddenProposal.ImageInfo &&
                prop.OverriddenProposal.ImageInfo.length > 0
            ) {
                this.partImages = prop.OverriddenProposal.ImageInfo.filter(
                    a => a.Type == 1
                );
                this.packageImages = prop.OverriddenProposal.ImageInfo.filter(
                    a => a.Type == 2
                );
            } else if (
                prop.OverriddenProposal.ImageInfo &&
                prop.OverriddenProposal.ImageInfo.length == 0
            ) {
                this.partImages = [];
                this.packageImages = [];
            }
        }
    }

    onRowSelectedChange(isSelected: boolean, partInfo: PartInfo) {
        if (isSelected) {
            this.partinfoList.find(a => a.PartNumber == partInfo.PartNumber && a.SourceTypeId == partInfo.SourceTypeId).IsSelected = true;
            if (
                this.partinfoList.filter(a => a.IsSelected == true).length ==
                this.partinfoList.length
            ) {
                this.allItemsCheckBoxSelected = true;
            }
        } else {
            this.partinfoList.find(a => a.PartNumber == partInfo.PartNumber && a.SourceTypeId == partInfo.SourceTypeId).IsSelected = false;
            this.allItemsCheckBoxSelected = false;
        }
        this.proposalService.RefreshPartInfoList(this.partinfoList);
    }

    levelExists(level: number) {
        const packageLevel = this.createproposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[level - 1];
        // return true if already the record has teh level
        if (packageLevel) {
            return true;
        } else {
            return false;
        }
    }

    imageUploaded(imageToBeUploaded: FileToBeUploaded) {
        this.newImageUploaded.emit(imageToBeUploaded);
    }

    imageDelete(imageToBeDeleted: ImageToBeDeleted) {
        this.imageDeleteClicked.emit(imageToBeDeleted);
    }

    getImageURL(image: ProposalImage) {
       if (image.DisplayUrl == undefined || image.DisplayUrl == null || image.DisplayUrl === '') {
                return image.UUId;
            } else {
                return image.DisplayUrl;
            }
    }

    setAllSelected(isSelected: boolean) {
        this.partinfoList.map(function(part) {
            part.IsSelected = isSelected;
            return part;
        });
        this.proposalService.RefreshPartInfoList(this.partinfoList);
    }
    resetFormErrors() {
        for (const field in this.formErrors) {
            if (field) {
              this.formErrors[field] = '';
            }
        }
    }

    setDunnageTypes(dunnageTypes: any) {
        if (dunnageTypes) {
            this.dunnageTypePrimaryList = dunnageTypes.filter(
                a => a.PackageLevelId == Constants.PRIMARY_LEVEL
            );
            this.dunnageTypeSecondaryList = dunnageTypes.filter(
                a => a.PackageLevelId == Constants.SECONDARY_LEVEL
            );
        }
    }

    DunnageTypeChanged(event: number[]) {
        const level = this.dunnageTypes.find(x => x.Id === event[0]).PackageLevelId;
        if (level === Constants.PRIMARY_LEVEL) {
            if (event.find(x => x === 7)) {
                this.PrimaryotherDunnageTypeSelected = true;
            } else {
                this.PrimaryotherDunnageTypeSelected = false;
            }
        }
        if (level === Constants.SECONDARY_LEVEL) {
            if (event.find(x => x === 11)) {
                this.SecondaryotherDunnageTypeSelected = true;
            } else {
                this.SecondaryotherDunnageTypeSelected = false;
            }
        }
    }

    ValidateForm(IsForSubmit: boolean = true) {
        this.resetFormErrors();
        // this.formErrors = this.FormService.validateForm(this.proposalOverrideForm, this.formErrors);
        this.formErrors = ValidateProposalOverrideFields(
            this.proposalOverrideForm,
            this.formErrors,
            true, !IsForSubmit
        );
        // mark form as invalid if any field in formErrors is populated
        if (
            Object.values(this.formErrors).find(function(element) {
                if (element) {
                    return element.length > 0;
                } else {
                    return false;
                }
            })
        ) {
            Object.keys(this.formErrors).forEach(field => {
                // this.ProposalPackageLevelForm.controls[field].setErrors({ field: true});
            });
        }
    }
}
